<template>
    <div>
        <el-card shadow="never" v-loading="formLoading">
            <el-form :inline="true" label-position="right" ref="form" :model="formData" :rules="rules" label-width="100px" size="small">
                <el-form-item label="实际表号" prop="actualNo">
                    <el-input size="small" v-model="formData.actualNo" placeholder="请输入实际表号" clearable></el-input>
                </el-form-item>
                <el-form-item label="电损" prop="loss">
                    <el-input-number v-model="formData.loss" :controls="false" placeholder="请输入电损" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="仪表类型" prop="meterType">
                    <el-select  clearable size="small" v-model="formData.meterType" placeholder="仪表类型">
                        <el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否公共" prop="isPublic">
                    <el-select  clearable size="small" v-model="formData.isPublic" placeholder="是否公共">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属房产" prop="roomId">
                    <room-select-tree v-model="formData.roomId" />
                </el-form-item>
                <el-form-item label="是否虚拟表" prop="dummyFlag">
                    <el-select  clearable size="small" v-model="formData.dummyFlag" placeholder="是否虚拟表">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input
                        size="small"
                        v-model="formData.remarks"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="请输入备注"
                        clearable
                    ></el-input>
                </el-form-item>
            </el-form>

            <div class="form-buttons-center">
                <el-button size="small" type="primary" :loading="saveLoading" @click="doSaveEditBasicInfo">确 定</el-button>
                <el-button size="small" @click="doClose">取 消</el-button>
            </div>
        </el-card>
    </div>
</template>
<script>
import '@/assets/scss/common.scss';
import dlgForm from "@/mixin/dlgForm";
import RoomSelectTree from "@/components/RoomSelectTree.vue";
import { options, meterType } from "@/dict/meterDict";
export default {
    name: "EditBasicInfoForm",
    mixins: [dlgForm],
    components: {RoomSelectTree},
    data() {
        return {
            options,
            meterType,
            rules: {
                actualNo: [
                    { required: true, message: '请输入实际表号', trigger: 'blur' }
                ],
                meterType: [
                    { required: true, message: '请选择仪表类型', trigger: 'blur' }
                ],
                isPublic: [
                    { required: true, message: '请选择是否是公共表', trigger: 'blur' }
                ],
                roomId: [
                    { required: true, message: '请选择房产', trigger: 'blur' }
                ],
                dummyFlag: [
                    { required: true, message: '请选择是否是虚拟表', trigger: 'blur' }
                ],
                loss: [
                    { required: true, message: '请输入电损', trigger: 'blur' },
                    { type: 'number', min: 1, message: '必须是正数', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        doSaveEditBasicInfo() {
            const url = `/meter/web/basic/${this.formData.id}`;
            this._doSaveForm(this.$refs.form, url, 'PUT');
		}
    }
}
</script>
<style scoped>
.el-input-number::v-deep .el-input__inner {
    text-align: left;
}
</style>